export default __webpack_public_path__ + "static/media/field.260cbaee.jpg";